var _style, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcosystem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 202 178.5",
    style: {
      enableBackground: "new 0 0 202 178.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 101.48,
    cy: 97.27,
    r: 24.87
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 101.48,
    cy: 24.68,
    r: 19.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 174.07,
    cy: 97.27,
    r: 19.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.89,
    cy: 97.27,
    r: 19.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.48,171.86c-41.13,0-74.59-33.46-74.59-74.59c0-41.13,33.46-74.59,74.59-74.59s74.59,33.46,74.59,74.59 C176.07,138.4,142.61,171.86,101.48,171.86z M101.48,26.68c-38.92,0-70.59,31.67-70.59,70.59s31.67,70.59,70.59,70.59 s70.59-31.67,70.59-70.59S140.41,26.68,101.48,26.68z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.48,144.51c-26.05,0-47.25-21.2-47.25-47.25s21.2-47.25,47.25-47.25c26.05,0,47.25,21.2,47.25,47.25 S127.53,144.51,101.48,144.51z M101.48,52.02c-24.95,0-45.25,20.3-45.25,45.25c0,24.95,20.3,45.25,45.25,45.25 s45.25-20.3,45.25-45.25C146.73,72.32,126.43,52.02,101.48,52.02z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosystem);
export default __webpack_public_path__ + "static/media/ecosystem.c4a2317114585f526e956600fec6a04a.svg";
export { ForwardRef as ReactComponent };